module.exports = __webpack_public_path__ + "img/refresh-player-black.f392bfe4.svg";